(function () {
    'use strict';

    angular.module('szallodak', [
        'ngMessages',
        'slick',
        'szallodak-room',
        'szallodak-partner',
        'szallodak-test',
        'szallodak-news',
        'szallodak-room-package',
        'szallodak-map',
        'szallodak-dailyprice',
        'szallodak-novacancy',
        'szallodak-home-screen',
        'szallodak-email-template',
        'szallodak-location',
        'szallodak-unique-offer',
        'szallodak-seo',
        'szallodak-searchadmin',
        'szallodak-unique-offer-response',
        'szallodak-cancellation-policy',
        'szallodak-accommodation',
        'szallodak-houserules',
        'szallodak-dashboard',
        'szallodak-payment-term',
        'szallodak-menugenerator',
        'szallodak-child-ages',
        'szallodak-supply',
        'szallodak-newsletter',
        'szallodak-accommodationservices'
    ]).filter('money', function () {
        return function (n) {
            var num = parseInt(n, 10);
            if (isNaN(num)) {
                return n;
            }
            num = ''+num;
            num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")+' Ft';
            return num;
        };
    }).constant('datepickerLocale', {
        'format': 'YYYY.MM.DD',
        'separator': ' - ',
        'applyLabel': 'Rendben',
        'cancelLabel': 'Mégsem',
        'fromLabel': 'Tól',
        'toLabel': 'Ig',
        'customRangeLabel': 'Egyedi',
        'weekLabel': 'hét',
        'daysOfWeek': [
            'Va',
            'Hé',
            'Ke',
            'Sz',
            'Cs',
            'Pé',
            'Szo',
        ],
        'monthNames': [
            'Január',
            'Február',
            'Március',
            'Április',
            'Május',
            'Június',
            'Július',
            'Augusztus',
            'Szeptember',
            'Október',
            'November',
            'December'
        ],
        'firstDay': 1
    });

})();
